import Core from '../Core'

export default (superclass) => class extends superclass {
  _publicWrapperForObjectWithIdentifier (name, args, objectName) {
    return Core.publicWrapper({
      name,
      arguments: args,
      parameters: [objectName, 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: objectName,
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
          ] },
      ],
    })
  }
  _publicWrapperWithCouponParameter (name, args) {
    return this._publicWrapperForObjectWithIdentifier(name, args, 'coupon')
  }
  _publicWrapperWithGoodyParameter (name, args) {
    return this._publicWrapperForObjectWithIdentifier(name, args, 'goody')
  }
  _publicWrapperWithReceiptUuidParameter (name, args) {
    return Core.publicWrapper({
      name,
      arguments: args,
      parameters: ['receiptUuid', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'receiptUuid', presence: true, type: 'string' },
      ],
    })
  }
  _publicWrapperForTimeline (name, args) {
    return Core.publicWrapper({
      name,
      arguments: args,
      parameters: ['limit', 'oldestSeenTimelineOrderedKey', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'limit', type: 'number', nan: false },
        { name: 'oldestSeenTimelineOrderedKey', type: 'string' },
      ],
    })
  }

  getTimeline () {
    return this._publicWrapperForTimeline('getTimeline', arguments)
  }
  getTimelineArchives () {
    return this._publicWrapperForTimeline('getTimelineArchives', arguments)
  }
  archiveMessage () {
    return this._publicWrapperForObjectWithIdentifier('archiveMessage', arguments, 'message')
  }

  getEarnedCoupons () {
    return this._publicWrapperWithoutParameter('getEarnedCoupons', arguments)
  }

  getCardSlots () {
    return this._publicWrapperWithoutParameter('getCardSlots', arguments)
  }
  getCardSlot () {
    return this._publicWrapperWithoutParameter('getCardSlot', arguments)
  }
  getCard () {
    return this._publicWrapperWithoutParameter('getCard', arguments)
  }

  getCatalog () {
    return this._publicWrapperWithoutParameter('getCatalog', arguments)
  }
  getCatalogs () {
    return this._publicWrapperWithoutParameter('getCatalogs', arguments)
  }

  getCardCatalog () {
    return Core.publicWrapper({
      name: 'getCardCatalog',
      arguments: arguments,
      parameters: ['card', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'card',
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
          ] },
      ],
    })
  }

  buyCoupon () {
    return this._publicWrapperWithCouponParameter('buyCoupon', arguments)
  }

  cancelCoupon () {
    return this._publicWrapperWithCouponParameter('cancelCoupon', arguments)
  }

  resellEarnedCouponAsPoints () {
    return Core.publicWrapper({
      name: 'resellEarnedCouponAsPoints',
      arguments: arguments,
      parameters: ['coupon', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'coupon',
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
            { name: 'resellable_as_points', presence: true },
          ] },
      ],
    })
  }

  resellEarnedCouponAsFidzs () {
    return Core.publicWrapper({
      name: 'resellEarnedCouponAsFidzs',
      arguments: arguments,
      parameters: ['coupon', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'coupon',
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
            { name: 'resellable_as_fidzs', presence: true },
          ] },
      ],
    })
  }

  selectNextGoal () {
    return this._publicWrapperWithCouponParameter('selectNextGoal', arguments)
  }

  cancelNextGoal () {
    return this._publicWrapperWithCouponParameter('cancelNextGoal', arguments)
  }

  cancelReceipt () {
    return this._publicWrapperWithReceiptUuidParameter('cancelReceipt', arguments)
  }

  skipReceiptValidation () {
    return this._publicWrapperWithReceiptUuidParameter('skipReceiptValidation', arguments)
  }

  showReceiptReview () {
    return this._publicWrapperWithReceiptUuidParameter('showReceiptReview', arguments)
  }

  validateReceiptReview () {
    return this._publicWrapperWithReceiptUuidParameter('validateReceiptReview', arguments)
  }

  claimOnPurchase () {
    return Core.publicWrapper({
      name: 'claimOnPurchase',
      arguments: arguments,
      parameters: ['purchaseId', 'ean', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'purchaseId', presence: true, type: 'string' },
        { name: 'ean',        presence: true, type: 'string' },
      ],
    })
  }

  trustingClaimOnPurchase () {
    return Core.publicWrapper({
      name: 'trustingClaimOnPurchase',
      arguments: arguments,
      parameters: ['purchaseId', 'cardIdentifier', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'purchaseId',     presence: true, type: 'string' },
        { name: 'cardIdentifier', presence: true, type: 'string' },
      ],
    })
  }

  claimOnReceipt () {
    return Core.publicWrapper({
      name: 'claimOnReceipt',
      arguments: arguments,
      parameters: ['receiptUuid', 'ean', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'receiptUuid', presence: true, type: 'string' },
        { name: 'ean',         presence: true, type: 'string' },
      ],
    })
  }

  reportOnReceipt () {
    return Core.publicWrapper({
      name: 'reportOnReceipt',
      arguments: arguments,
      parameters: ['receiptUuid', 'message', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'receiptUuid', presence: true, type: 'string' },
        { name: 'message',     presence: true, type: 'string' },
      ],
    })
  }

  getAvailableEarnedCoupons () {
    return this._publicWrapperWithoutParameter('getAvailableEarnedCoupons', arguments)
  }

  claimEarnedCouponOnReceipt () {
    return Core.publicWrapper({
      name: 'claimEarnedCouponOnReceipt',
      arguments: arguments,
      parameters: ['receiptUuid', 'coupon', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'receiptUuid', presence: true, type: 'string' },
        { name: 'coupon',
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
          ] },
      ],
    })
  }

  neededFieldsForGoody () {
    return this._publicWrapperWithGoodyParameter('neededFieldsForGoody', arguments)
  }
  orderGoody () {
    return Core.publicWrapper({
      name: 'orderGoody',
      arguments: arguments,
      parameters: ['goody', 'userInformations', 'onSuccess', 'onFailure', 'onComplete'],
      validations: [
        { name: 'goody',
          presence: true,
          type: 'object',
          properties: [
            { name: 'identifier', presence: true, type: 'string' },
          ] },
        { name: 'userInformations',
          presence: true,
          type: 'object' },
      ],
    })
  }
}
